import VideoModal from './video-modal';

export default VideoModal;
